import { useLocation } from "@reach/router";
import { FC, useEffect } from 'react';
import CookieConsent from "react-cookie-consent";
import ga4 from "react-ga4";
import GoTop from './GoTop';
import { Link, useTranslation } from '../../plugins/i18next/ea-react-i18next';
import Navbar from "./Navbar";
import NewsletterBanner from "./NewsletterBanner";
import Footer from "./Footer";

type Props = {
  children?: React.ReactNode
};

const Layout: FC<Props> = ({ children }) => {
  const location = useLocation();
 const {t} = useTranslation();

  const handleAcceptCookie = () => {
    if (process.env.GATSBY_GOOGLE_ANALYTICS_ID) {
      ga4.initialize(process.env.GATSBY_GOOGLE_ANALYTICS_ID);
      ga4.send({ hitType: "pageview", path: location.pathname });
    }
  };

  useEffect(() => {
    handleAcceptCookie();
  }, []);

  return (<div>
    <Navbar />
    <NewsletterBanner/>
    {children}    
    <Footer />
    <GoTop scrollStepInPx={100} delayInMs={10} />
    <CookieConsent buttonText={t('app.layout.buttonText')} declineButtonText="Decline" buttonClasses="acceptConsent" declineButtonClasses="declineConsent" onAccept={handleAcceptCookie}>
      <p> {t('app.layout.cookieConsent')} <Link to="/legal/web/privacy">{t('app.layout.privacyPolicy')}</Link>.</p>
    </CookieConsent>
  </div>
  )
}

export default Layout

